import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { uploadCompressFile } from '@helper/fileUpload';

interface IImageUploadData {
	url?: string;
	imageSource?: File | null;
}

interface IImageUploadResponse {
	mutate: UseMutateFunction<unknown, Error, IImageUploadData, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useCommonImageUpload = (): IImageUploadResponse => {
	const imageUploadFn = async (imageData: IImageUploadData): Promise<unknown> => {
		if (imageData.url && imageData.imageSource) {
			return uploadCompressFile(imageData.imageSource, imageData?.url);
		}
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: imageUploadFn,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
